// extracted by mini-css-extract-plugin
export default {"pic":"SearchSectionItem__pic--1xg5K"};